import { create } from 'zustand';

export type SessionMode = 'loading' | 'signed-out' | 'not-allowed' | 'live' | 'demo';

interface SessionState {
  mode: SessionMode;
  userId: string | null;
  email: string | null;
  /** Set once the local database is open and (for live mode) the first pull finished. */
  ready: boolean;
  set: (patch: Partial<Omit<SessionState, 'set'>>) => void;
}

export const useSession = create<SessionState>((set) => ({
  mode: 'loading',
  userId: null,
  email: null,
  ready: false,
  set: (patch) => set(patch),
}));

export function currentUserId(): string {
  const id = useSession.getState().userId;
  if (!id) throw new Error('No user');
  return id;
}

export function isLive(): boolean {
  return useSession.getState().mode === 'live';
}
